import React, { useState } from "react";
import { Button, Menu, MenuItem, useTheme } from "@mui/material";
import { ChevronDown } from "lucide-react";
import { ButtonTertiary } from "src/UI/ButtonTertiary";

export interface SortMenuOption {
  label: string;
  value: string;
}

interface SortMenuCstProps {
  id: string;
  value: string;
  options: SortMenuOption[];
  onChange: (value: string) => void;
}

const SortMenuCst: React.FC<SortMenuCstProps> = ({
  id,
  value,
  options,
  onChange,
}) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const selected = options.find((o) => o.value === value);

  const handleSelect = (next: string) => {
    setAnchorEl(null);
    if (next !== value) onChange(next);
  };

  return (
    <>
      <ButtonTertiary
        // id={id}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        endIcon={<ChevronDown size={18} />}
        aria-haspopup="menu"
        aria-expanded={open ? "true" : undefined}
      >
        {selected?.label ?? options[0]?.label ?? ""}
      </ButtonTertiary>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            mt: "6px",
            minWidth: 230,
            borderRadius: "12px",
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper,
            backgroundImage: "none",
            padding: "6px",
          },
        }}
        MenuListProps={{
          sx: {
            padding: 0,
            border: "none",
            display: "flex",
            flexDirection: "column",
            gap: "2px",
          },
        }}
      >
        {options.map((option) => {
          const isSelected = option.value === value;
          return (
            <MenuItem
              key={option.value}
              selected={isSelected}
              onClick={() => handleSelect(option.value)}
              sx={{
                fontSize: "14px",
                color: theme.palette.text.primary,
                borderRadius: "8px",
                border: `1px solid ${
                  isSelected ? theme.palette.primary.main : "transparent"
                }`,
                padding: "8px 12px",
                "&.Mui-selected": {
                  backgroundColor: "transparent",
                },
                "&.Mui-selected:hover": {
                  backgroundColor: theme.palette.action.hover,
                },
              }}
            >
              {option.label}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default SortMenuCst;
